import styles from './Style.module.css'

export const SaleCancelReason = ({reason, remark, customClass}) => {
  return (
    <div className={`${styles.noteContainer} ${customClass}`}>
        <label>Reason:</label>
        <p>{reason} {remark && <>({remark})</>}</p>
    </div>
  )
}
